webpackJsonp([137591856104208],{

/***/ 1411:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.striptags = factory();
	  }
	}(this, function () {
	    var STATE_OUTPUT       = 0,
	        STATE_HTML         = 1,
	        STATE_PRE_COMMENT  = 2,
	        STATE_COMMENT      = 3,
	        WHITESPACE         = /\s/,
	        ALLOWED_TAGS_REGEX = /<(\w*)>/g;
	
	    function striptags(html, allowableTags) {
	        var html = html || '',
	            state = STATE_OUTPUT,
	            depth = 0,
	            output = '',
	            tagBuffer = '',
	            inQuote = false,
	            i, length, c;
	
	        if (typeof allowableTags === 'string') {
	            // Parse the string into an array of tags
	            allowableTags = parseAllowableTags(allowableTags);
	        } else if (!Array.isArray(allowableTags)) {
	            // If it is not an array, explicitly set to null
	            allowableTags = null;
	        }
	
	        for (i = 0, length = html.length; i < length; i++) {
	            c = html[i];
	
	            switch (c) {
	                case '<': {
	                    // ignore '<' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // '<' followed by a space is not a valid tag, continue
	                    if (html[i + 1] == ' ') {
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // change to STATE_HTML
	                    if (state == STATE_OUTPUT) {
	                        state = STATE_HTML;
	
	                        consumeCharacter(c);
	                        break;
	                    }
	
	                    // ignore additional '<' characters when inside a tag
	                    if (state == STATE_HTML) {
	                        depth++;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '>': {
	                    // something like this is happening: '<<>>'
	                    if (depth) {
	                        depth--;
	                        break;
	                    }
	
	                    // ignore '>' if inside a quote
	                    if (inQuote) {
	                        break;
	                    }
	
	                    // an HTML tag was closed
	                    if (state == STATE_HTML) {
	                        inQuote = state = 0;
	
	                        if (allowableTags) {
	                            tagBuffer += '>';
	                            flushTagBuffer();
	                        }
	
	                        break;
	                    }
	
	                    // '<!' met its ending '>'
	                    if (state == STATE_PRE_COMMENT) {
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    // if last two characters were '--', then end comment
	                    if (state == STATE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '-') {
	
	                        inQuote = state = 0;
	                        tagBuffer = '';
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                // catch both single and double quotes
	                case '"':
	                case '\'': {
	                    if (state == STATE_HTML) {
	                        if (inQuote == c) {
	                            // end quote found
	                            inQuote = false;
	                        } else if (!inQuote) {
	                            // start quote only if not already in one
	                            inQuote = c;
	                        }
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '!': {
	                    if (state == STATE_HTML &&
	                        html[i - 1] == '<') {
	
	                        // looks like we might be starting a comment
	                        state = STATE_PRE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case '-': {
	                    // if the previous two characters were '!-', this is a comment
	                    if (state == STATE_PRE_COMMENT &&
	                        html[i - 1] == '-' &&
	                        html[i - 2] == '!') {
	
	                        state = STATE_COMMENT;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                case 'E':
	                case 'e': {
	                    // check for DOCTYPE, because it looks like a comment and isn't
	                    if (state == STATE_PRE_COMMENT &&
	                        html.substr(i - 6, 7).toLowerCase() == 'doctype') {
	
	                        state = STATE_HTML;
	                        break;
	                    }
	
	                    consumeCharacter(c);
	                    break;
	                }
	
	                default: {
	                    consumeCharacter(c);
	                }
	            }
	        }
	
	        function consumeCharacter(c) {
	            if (state == STATE_OUTPUT) {
	                output += c;
	            } else if (allowableTags && state == STATE_HTML) {
	                tagBuffer += c;
	            }
	        }
	
	        function flushTagBuffer() {
	            var normalized = '',
	                nonWhitespaceSeen = false,
	                i, length, c;
	
	            normalizeTagBuffer:
	            for (i = 0, length = tagBuffer.length; i < length; i++) {
	                c = tagBuffer[i].toLowerCase();
	
	                switch (c) {
	                    case '<': {
	                        break;
	                    }
	
	                    case '>': {
	                        break normalizeTagBuffer;
	                    }
	
	                    case '/': {
	                        nonWhitespaceSeen = true;
	                        break;
	                    }
	
	                    default: {
	                        if (!c.match(WHITESPACE)) {
	                            nonWhitespaceSeen = true;
	                            normalized += c;
	                        } else if (nonWhitespaceSeen) {
	                            break normalizeTagBuffer;
	                        }
	                    }
	                }
	            }
	
	            if (allowableTags.indexOf(normalized) !== -1) {
	                output += tagBuffer;
	            }
	
	            tagBuffer = '';
	        }
	
	        return output;
	    }
	
	    /**
	     * Return an array containing tags that are allowed to pass through the
	     * algorithm.
	     *
	     * @param string allowableTags A string of tags to allow (e.g. "<b><strong>").
	     * @return array|null An array of allowed tags or null if none.
	     */
	    function parseAllowableTags(allowableTags) {
	        var tagsArray = [],
	            match;
	
	        while ((match = ALLOWED_TAGS_REGEX.exec(allowableTags)) !== null) {
	            tagsArray.push(match[1]);
	        }
	
	        return tagsArray.length !== 0 ? tagsArray : null;
	    }
	
	    return striptags;
	}));


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _class, _temp;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    top: 80px;\n  '], ['\n    top: 80px;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    flex-direction: row;\n  '], ['\n    flex-direction: row;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n      margin-bottom: ', ';\n    '], ['\n      margin-bottom: ', ';\n    ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(15);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(35);
	
	var _striptags = __webpack_require__(1411);
	
	var _striptags2 = _interopRequireDefault(_striptags);
	
	var _jsCookie = __webpack_require__(50);
	
	var _cart = __webpack_require__(19);
	
	var _ui = __webpack_require__(56);
	
	var _types = __webpack_require__(20);
	
	var _shared = __webpack_require__(7);
	
	var _styles = __webpack_require__(6);
	
	var _guestCartCookieName = __webpack_require__(44);
	
	var _guestCartCookieName2 = _interopRequireDefault(_guestCartCookieName);
	
	var _components = __webpack_require__(440);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var sp = _styles.theme.sp,
	    colors = _styles.theme.colors;
	
	
	var CartBar = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'ProductPage__CartBar'
	})(['top:60px;left:0;right:0;z-index:999;', ';'], _styles.media.ldesktop(_templateObject));
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'ProductPage__Wrapper'
	})(['background:', ';padding-bottom:100px;font-size:18px;.sticky{position:relative;z-index:10000;}'], colors.white);
	
	var Main = /*#__PURE__*/(0, _styledComponents2.default)(_shared.Container).withConfig({
	  displayName: 'ProductPage__Main'
	})(['display:flex;flex-direction:column;margin-top:80px;', ';'], _styles.media.tablet(_templateObject2));
	
	var MainWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'ProductPage__MainWrapper'
	})(['flex:1;p,ul,ol{counter-reset:item;line-height:1.4;font-weight:400;margin-bottom:', ';', ';}ol,ul{padding:0;}ul li{position:relative;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:15px;left:0;width:20px;height:2px;background-color:', ';content:\'\';}}ol li{position:relative;counter-increment:item;list-style:none;padding-left:40px;margin-bottom:', ';&::before{position:absolute;top:0;left:0;content:counters(item,\'\') \'.\';color:', ';width:20px;}}.fixed-bar{position:fixed;}'], sp.l, _styles.media.tablet(_templateObject3, sp.xl), sp.s, colors.blue, sp.s, colors.blue);
	
	var DescriptionWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'ProductPage__DescriptionWrapper'
	})(['']);
	
	var Description = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'ProductPage__Description'
	})(['width:80%;']);
	
	var MainTitle = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'ProductPage__MainTitle'
	})(['margin-bottom:', ';color:', ';font-size:16px;'], sp.l, colors.grey);
	
	var AddToCartWrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'ProductPage__AddToCartWrapper'
	})(['width:100%;background:', ';'], colors.navy);
	
	var ProductPage = (_temp = _class = function (_React$Component) {
	  _inherits(ProductPage, _React$Component);
	
	  function ProductPage(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, ProductPage);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.addToCart = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(quantity, months, recurring) {
	        var cartId;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                cartId = (0, _jsCookie.get)(_guestCartCookieName2.default);
	
	                _this.props.onAddItem(cartId, {
	                  sellableId: _this.props.product.id,
	                  sellableType: 'Product',
	                  quantity: quantity,
	                  months: months,
	                  recurring: recurring
	                });
	
	              case 2:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2, _x3) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {};
	
	    _this.handleScroll = _this.handleScroll.bind(_this);
	    return _this;
	  }
	
	  ProductPage.prototype.componentWillMount = function componentWillMount() {
	    this.props.onToggleAddToCart();
	  };
	
	  ProductPage.prototype.componentDidMount = function componentDidMount() {
	    /* eslint-disable react/no-did-mount-set-state */
	    var cb = document.getElementById('cartbar');
	    if (cb !== null) {
	      this.setState({ top: cb.offsetTop, height: cb.offsetHeight });
	      this.setState({ scrollNeeded: _styles.media.ldesktop ? 80 : 60 });
	    }
	    window.addEventListener('scroll', this.handleScroll);
	  };
	
	  ProductPage.prototype.componentDidUpdate = function componentDidUpdate() {
	    /* eslint no-unused-expressions: [2, { allowShortCircuit: true, allowTernary: true }] */
	    this.state.scroll > this.state.top ? document.body.style.paddingTop = this.state.height + 'px' : document.body.style.paddingTop = 0;
	  };
	
	  ProductPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.onToggleAddToCart();
	  };
	
	  ProductPage.prototype.handleScroll = function handleScroll() {
	    this.setState({ scroll: window.scrollY + this.state.scrollNeeded });
	  };
	
	  ProductPage.prototype.render = function render() {
	    var product = this.props.product;
	    var seoTitle = product.seoTitle,
	        seoKeywords = product.seoKeywords,
	        seoDescription = product.seoDescription;
	
	
	    return _react2.default.createElement(
	      Wrapper,
	      null,
	      _react2.default.createElement(_shared.SeoTags, {
	        title: seoTitle,
	        keywords: seoKeywords,
	        description: seoDescription
	      }),
	      _react2.default.createElement(_components.Header, { product: product }),
	      _react2.default.createElement(
	        CartBar,
	        {
	          id: 'cartbar',
	          style: {
	            position: this.state.scroll > this.state.top ? 'fixed' : 'initial'
	          }
	        },
	        _react2.default.createElement(
	          AddToCartWrapper,
	          null,
	          _react2.default.createElement(_shared.AddToCart, { product: product, onAddToCart: this.addToCart })
	        )
	      ),
	      _react2.default.createElement(
	        Main,
	        null,
	        _react2.default.createElement(
	          MainWrapper,
	          null,
	          _react2.default.createElement(
	            DescriptionWrapper,
	            null,
	            _react2.default.createElement(
	              MainTitle,
	              null,
	              'Description'
	            ),
	            _react2.default.createElement(Description, {
	              dangerouslySetInnerHTML: { __html: product.description }
	            })
	          )
	        ),
	        !(0, _lodash.isEmpty)((0, _striptags2.default)(product.benefitsAndDeliverables)) && _react2.default.createElement(
	          MainWrapper,
	          null,
	          _react2.default.createElement(
	            DescriptionWrapper,
	            null,
	            _react2.default.createElement(
	              MainTitle,
	              null,
	              'Benefits / Deliverables'
	            ),
	            _react2.default.createElement(Description, {
	              dangerouslySetInnerHTML: {
	                __html: product.benefitsAndDeliverables
	              }
	            })
	          )
	        )
	      )
	    );
	  };
	
	  return ProductPage;
	}(_react2.default.Component), _class.propTypes = {
	  product: _types.ProductType.isRequired,
	  onAddItem: _propTypes2.default.func.isRequired,
	  onToggleAddToCart: _propTypes2.default.func.isRequired
	}, _temp);
	
	
	var mapStateToProps = function mapStateToProps() {
	  return {};
	};
	
	var mapDispatchToProps = {
	  onAddItem: _cart.addItem,
	  onToggleAddToCart: _ui.toggleAddToCart
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ProductPage);
	module.exports = exports['default'];

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    display: flex;\n  '], ['\n    display: flex;\n  ']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    width: 40%;\n  '], ['\n    width: 40%;\n  ']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n    width: 60%;\n    margin: 0;\n  '], ['\n    width: 60%;\n    margin: 0;\n  ']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(15);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _types = __webpack_require__(20);
	
	var _styles = __webpack_require__(6);
	
	var _cart = __webpack_require__(19);
	
	var _routes = __webpack_require__(24);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _shared = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledHeader = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__StyledHeader'
	})(['display:flex;background-color:', ';padding:', ' 0;'], _styles.theme.colors.blueIce, _styles.theme.sp.xl);
	
	var Wrapper = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__Wrapper'
	})(['margin:', ' 0;', ';'], _styles.theme.sp.xl, _styles.media.tablet(_templateObject));
	
	var Content = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__Content'
	})(['margin-top:', ';', ';'], _styles.theme.sp.xl, _styles.media.tablet(_templateObject2));
	
	var Image = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'Header__Image'
	})(['line-height:0;margin-top:', ';', ';img{max-width:100%;}'], _styles.theme.sp.xl, _styles.media.tablet(_templateObject3));
	
	var Name = /*#__PURE__*/_styledComponents2.default.h1.withConfig({
	  displayName: 'Header__Name'
	})(['font-size:36px;line-height:42px;font-weight:700;margin-bottom:', ';'], _styles.theme.sp.s);
	
	var Price = /*#__PURE__*/_styledComponents2.default.h2.withConfig({
	  displayName: 'Header__Price'
	})(['font-size:36px;line-height:42px;font-weight:500;color:', ';'], _styles.theme.colors.royal);
	
	var propTypes = {
	  product: _types.ProductType.isRequired,
	  currency: _propTypes2.default.string.isRequired
	};
	
	var defaultProps = {};
	
	function Header(_ref) {
	  var product = _ref.product,
	      currency = _ref.currency;
	
	  var breadcrumbs = [{
	    name: 'Home',
	    link: '' + _routes2.default.home.index
	  }, {
	    name: 'Services',
	    link: '' + _routes2.default.products.index
	  }, {
	    name: '' + product.productCategories[0].name,
	    link: (0, _routes.routeFor)(_routes2.default.products.category, product.productCategories[0].slug)
	  }, {
	    name: product.name,
	    link: (0, _routes.routeFor)(_routes2.default.products.show, product.productCategories[0].slug, product.slug)
	  }];
	
	  return _react2.default.createElement(
	    StyledHeader,
	    null,
	    _react2.default.createElement(
	      _shared.Container,
	      null,
	      _react2.default.createElement(_shared.Breadcrumbs, { left: true, breadcrumbs: breadcrumbs }),
	      _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            Name,
	            null,
	            product.name
	          ),
	          _react2.default.createElement(
	            Price,
	            null,
	            product.prices[currency].formattedPrice
	          )
	        ),
	        _react2.default.createElement(
	          Image,
	          null,
	          _react2.default.createElement('img', {
	            src: '' + ("") + product.bannerImageUrl.full,
	            alt: product.name
	          })
	        )
	      )
	    )
	  );
	}
	
	Header.propTypes = propTypes;
	Header.defaultProps = defaultProps;
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    currency: (0, _cart.getCartCurrency)(state)
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Header);
	module.exports = exports['default'];

/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Header = __webpack_require__(438);
	
	var _Header2 = _interopRequireDefault(_Header);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _Header2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Header = undefined;
	
	var _Header = __webpack_require__(439);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Header = _Header2.default;

/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProductPage = __webpack_require__(437);
	
	var _ProductPage2 = _interopRequireDefault(_ProductPage);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = _ProductPage2.default;
	module.exports = exports['default'];

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ProductPage = __webpack_require__(441);
	
	var _ProductPage2 = _interopRequireDefault(_ProductPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  data: _propTypes2.default.shape({ marketTapProduct: _propTypes2.default.object }).isRequired
	};
	
	function ProductPageContainer(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(_ProductPage2.default, { product: data.marketTapProduct });
	}
	
	ProductPageContainer.propTypes = propTypes;
	
	exports.default = ProductPageContainer;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-js-e89c192da64ac5c0e77d.js